import styled from 'styled-components'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 80vh;
  width: 90vw;
  border-radius: 8px;
  max-width: 642px;
  background: white;
  overflow: hidden;
`

export const CloseButton = styled.button`
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;
`

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
`

export const ModalContentTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
  color: #183b43;
  text-align: center;
  margin-bottom: 32px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f7f7f6;
  overflow-y: auto;
  padding: 24px 32px 54px;
`

export const StepImage = styled.img`
  margin-top: 16px;
`

export const SubTitle = styled.p`
  margin: 16px 0 0;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1.5;
  color: #179895;

  &:first-of-type {
    margin-top: 0;
  }
`

export const TruemedModalHeader = styled.img``

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  color: #103b40;
  white-space: normal;

  strong {
    font-weight: 700;
  }

  span[aria-hidden='true'] {
    opacity: 0.4;
    padding: 0 6px;
  }
`
